import * as types from "../types/foodPageUiState"

export const showFoodSidebar = () => ({
  type: types.SHOW_FOOD_SIDEBAR
})

export const hideFoodSidebar = () => ({
  type: types.HIDE_FOOD_SIDEBAR
})

export const showFoodSearchBar = () => ({
  type: types.SHOW_FOOD_SEARCH_BAR
})

export const hideFoodSearchBar = () => ({
  type: types.HIDE_FOOD_SEARCH_BAR
})

export const toggleFoodSearchBar = () => ({
  type: types.TOGGLE_FOOD_SEARCH_BAR
})

export const toggleFoodSidebar = () => ({
  type: types.TOGGLE_FOOD_SIDEBAR
})